import { Component, h, ComponentInterface, Prop, Host } from '@stencil/core';

@Component({
  tag: 'card-body',
})
export class CardBody implements ComponentInterface {
  /**
   * The title of the card body component.
   */
  @Prop() cardTitle: string;

  render() {
    return (
      <Host class="card-body">
        {this.cardTitle && (
          <header class="body-header">
            {this.cardTitle && <h3 class="heading">{this.cardTitle}</h3>}
          </header>
        )}
        <div class="body-text">
          <slot />
        </div>
      </Host>
    );
  }
}
